module.exports = __webpack_public_path__ + "img/appltCourse-img28.7be0424e.png";